import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from 'react-scroll';
import { FaStar, FaTools, FaPlane, FaUsers } from 'react-icons/fa';
// import TawkToWidget from "./TawkToWidget";
 import TestimonialSlider from './TestimonialSlider';
//import portContainer from './Images/industrial-port-container-yard.jpg';
import HomePageSlider1 from './Images/HomePageSlide1.png';
import HomePageSlide2 from './Images/HomePageSlide2.png';
import HomePageSlide3 from './Images/HomePageSlide3.png';
import { NavLink } from 'react-router-dom';
// import map from './Images/map.jpg';
import MobileViewCard from"./MobileViewCard";
import MobileViewCertificate from "./MobileViewCertificate";
import './App.css';
import Counter from "./Counter";
import Map from "./Map";
import Chemical from "./Images/Chemical .jpg";
import Ecxipient from "./Images/Excipient.jpg";
import Intermedite from "./Images/Intermedite.jpg";
import cosmetic from "./Images/Cosmetic.png";
import flavourAndFrafrance from "./Images/Flavour and fragrance.png";
import InOrganic from "./Images/InOrganic.jpg";
import PharmaAndFood from "./Images/PharmaAndFoodGrade.png";
import Water from "./Images/WaterAndMinning.png";
import Certificate1 from "./Images/ImportExportCertificate.png";
import URC1 from "./Images/URC-1.png";
import URC2 from "./Images/URC-2.png";
import logo from "./Images/aman logo.png";
import ProductImage1 from "./Images/ProductImage1.jpg";
import ProductImage2 from "./Images/ProductImage2.jpg";
import ProductImage3 from "./Images/ProductImage3.jpg";
import ProductImage4 from "./Images/ProductImage4.jpg";
import ProductImage5 from "./Images/ProductImage5.jpg";
import ProductImage6 from "./Images/ProductImage6.jpg";
import ApiProductImage from "./Images/Api.jpg";
import WelcomeScreen from "./WelcomeScreen";




const slides = [
  {
    image: HomePageSlide2,
    heading: "Trusted Supplier of Pharma Excipients & Chemicals",
    paragraph: <><span className="firstSlidee">Delivering quality active ingredients and chemicals for pharmaceuticall applications.</span></>,
    buttonText: "CONTACT NOW",
    buttonLink: { pathname: "/contact", state: { scrollTo: "form" } }

  },
  
  {
    image: HomePageSlider1,
    heading: <><span className="homePageSlide1 ">Global Presence, Local Reach</span></>,
    paragraph: <><span className="homePageSlide1 ">Serving in <span className="highlight-number">120+</span> Countries & Counting.</span></>,
    buttonText: "LEARN MORE",
    buttonLink: "/search"
  },
  {
    image: HomePageSlide3,
    heading: "Innovative Solution for Diverse Applications",
    paragraph: <>Catering to <span className="highlight-number">9+</span> Industry Verticals through Tailor-made Solutions.</>,
    buttonText: "VIEW INDUSTRIES",
    buttonLink: "#ViewIndustries"
    
  }
  
];
function App() {


  const [index, setIndex] = useState(0);
  const [showWelcome, setShowWelcome] = useState(false);
 
useEffect(() => {
    const alreadyShown = sessionStorage.getItem("welcomeShown");

    if (!alreadyShown) {
      setShowWelcome(true);
      sessionStorage.setItem("welcomeShown", "true"); // ✅ sirf first time
    }
  }, []);

  if (showWelcome) {
    return <WelcomeScreen onFinish={() => setShowWelcome(false)} />;
  }

  return (
    <div >

     
      {/* Image Slider Section */}
      <div className="slider-container">
        <div
          className="slider-track"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {slides.map((slide, i) => (
            <div className={`slide ${i === 1 ? 'move-up' : ''}`} key={i}>
              <img src={slide.image} alt={`Slide ${i}`} className="slider-image" />
              <div className="slider-content">
                <h2>{slide.heading}</h2>
                <p>{slide.paragraph}</p>
                {slide.buttonText === "VIEW INDUSTRIES" ? (
                  <ScrollLink to="ViewIndustries" smooth={true} duration={800} offset={-80} className="slider-button">
                    {slide.buttonText}
                  </ScrollLink>
                ) : (
                  <Link to={slide.buttonLink} className="slider-button">
                    {slide.buttonText}
                  </Link>
                )}

              </div>
            </div>
          ))}


        </div>

        {/* Navigation Dots */}
        <div className="dots-container">
          {slides.map((_, i) => (
            <div
              key={i}
              className={`dot ${i === index ? 'active' : ''}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>

      </div>


           


      <div className="glc-container">
        {/* First Row: Heading and Description */}
        <div className="glc-row">
          <div className="glc-heading">
            <h1>Welcome to Global Link Corporation (GLC)</h1>
          </div>
          <div className="glc-description">
            <p>
              Global Link Corporation (GLC) is a global leader in chemical distribution and manufacturing,
              offering comprehensive solutions across diverse industries. With decades of experience, GLC
              has established itself as a trusted partner, blending unmatched technical expertise and
              strategic marketing insights to drive value throughout the supply chain. Our innovative
              approach and dedication to quality ensure that GLC remains at the forefront of the industry,
              delivering customized solutions tailored to meet each customer’s unique requirements.
            </p>
          </div>
        </div>

        {/* Second Row: Services */}
        <div className="glc-services-modern">
          <div className="glc-service-card glc-service-card1">
            <div className="glc-icon-circle glc-icon-circle1"><FaStar /></div>
            <h3 className="glc-title glc-title1">Centralized Procurement</h3>
            <p className="glc-desc">
              Leveraging economies of scale, our centralized procurement function ensures that our clients have access to high-quality chemicals at competitive rates.
            </p>
          </div>

          <div className="glc-service-card glc-service-card2">
            <div className="glc-icon-circle glc-icon-circle2"><FaTools /></div>
            <h3 className="glc-title">Contract Manufacturing</h3>
            <p className="glc-desc">
              Our contract manufacturing services deliver customized chemical formulations, ensuring consistency, quality, and compliance with international standards.
            </p>
          </div>

          <div className="glc-service-card glc-service-card1">
            <div className="glc-icon-circle glc-icon-circle1">
              <FaPlane className="rotated-plane" />
            </div>

            <h3 className="glc-title glc-title1">Research & Development (R&D)</h3>
            <p className="glc-desc">
              With an emphasis oninnovation, our R&D teams work to develop cutting- edgesolutions that meet emerging industry needs and customer demands.
            </p>
          </div>

          <div className="glc-service-card glc-service-card2">
            <div className="glc-icon-circle glc-icon-circle2"><FaUsers /></div>
            <h3 className="glc-title">Supply Chain Management</h3>
            <p className="glc-desc">
              GLC’s efficient supply chain operations streamline logistics, reduce lead times, and ensuretimely deliveries for our customers worldwide.
            </p>
          </div>
        </div>

      </div>



     

      <div className="industries-sections" id="ViewIndustries" >
        <h2 className="industries-headings">Industries We Serve</h2>
        <h6 className="industries-subtexts">Delivering tailored chemical solutions across diverse sectors worldwide.</h6>
      </div>





      <div className='App'>
        <div className='CircleRow1'>
          <div className='HomeWrapper'>
            <div className='HomePageSmallCircle1 HomePageSmallCircle'>
              <h4>API <br />Products</h4>
            </div>

            <NavLink to="/ApiProductList">
            <div className='HomePageCircle '>

                <img src={ApiProductImage} alt='Home' />
            </div>
            </NavLink>
          </div>

          <div className='HomeWrapper'>
            <div className='HomePageSmallCircle HomePageSmallCircle2'>
              <h4>Inter..<br />mediates<br />List</h4>
            </div>

            <NavLink to="/IntermediatesList">
            <div className='HomePageCircle'>
                <img src={Intermedite} alt='Home' />
            </div>
            </NavLink>
          </div>

          <div className='HomeWrapper'>
            <div className='HomePageSmallCircle3 HomePageSmallCircle'>
              <h4>Excipients<br />List</h4>
            </div>

            <NavLink to="/ExcipientsList">
            <div className='HomePageCircle'>
                <img src={Ecxipient} alt='Home' />

            </div>
            </NavLink>
          </div>



          <div className='fourthimg  HomeWrapper forthimg'>
            <div className='HomePageSmallCircle4 HomePageSmallCircle'>
              <h4>Inorganic<br />Chemicals<br />List</h4>


            </div>
            <NavLink to="/InorganicChemicalsList">
            <div className='HomePageCircle'>
                <img src={InOrganic} alt='Home' />
            </div>
            </NavLink>
          </div>
        </div>

        <div className='CircleRow2'>

          <div className='HomeWrapper'>
            <div className='HomePageSmallCircle HomePageSmallCircle5'>
              <h4>Organic <br />Chemicals<br />List</h4>
            </div>
            <NavLink to="/OrganicChemicalsList">
            <div className='HomePageCircle1'>
                <img src={Chemical} alt='Home' />
            </div>
            </NavLink>
          </div>

          <div className='HomeWrapper Sixandeight'>
            <div className='HomePageSmallCircle HomePageSmallCircle6'>
              <h4>Cosmatics<br />PersonalCare<br />Products</h4>
            </div>

            <NavLink to="/CosmaticsandPersonalCareProducts">
            <div className='HomePageCircle2 sixhtimg'>
                <img src={cosmetic} alt='Home' />
            </div>
            </NavLink>
          </div>

          <div className='HomeWrapper'>
            <div className='HomePageSmallCircle HomePageSmallCircle7'>
              <h4>Pharma & <br />Food Grade<br />Oils</h4>
            </div>
            <NavLink to="/PharmaAndFoodGradeOils">
            <div className='HomePageCircle1'>
                <img src={PharmaAndFood} alt='Home' />
            </div>
            </NavLink>
          </div>


          <div className='HomeWrapper Sixandeight'>
            <div className='HomePageSmallCircle HomePageSmallCircle8'>
              <h4>Water<br />Treatment<br />&Mining</h4>
            </div>
            <NavLink to="/WaterTreatmentMining">
            <div className='HomePageCircle2 eighthimg'>
                <img src={Water} alt='Home' />
            </div>
            </NavLink>
          </div>


          <div className='HomeWrapper'>
            <div className='HomePageSmallCircle HomePageSmallCircle9'>
              <h4>Flavour&<br />Fragrance</h4>
            </div>
            <NavLink to="/FlavourFragrance">
            <div className='HomePageCircle2'>
                <img src={flavourAndFrafrance} alt='Home' />
            </div>
            </NavLink>
          </div>

        </div>



      </div>

     
      


      <div class="card-container">
        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <img src={ProductImage1} alt="Front Side" />
            </div>
            <div className="flip-card-back">
              <div className="card-back-content">
                <img src={ProductImage5} alt="Back" />
                {/* <p className="caption"> certification</p> */}
              </div>
            </div>
          </div>
        </div>
        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <img src={ProductImage6} alt="Front Side" />
            </div>
            <div className="flip-card-back">
              <div className="card-back-content">
                <img src={ProductImage3} alt="Back" />
                {/* <p className="caption">Certificate</p> */}
              </div>
            </div>

          </div>
        </div>
        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <img src={ProductImage4} alt="Front Side" />
            </div>
            <div className="flip-card-back">
              <div className="card-back-content">
                <img src={ProductImage2} alt="Back" />

                {/* <p className="caption">
                  certification
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>




      {/* <div className="image-containerMap">
        <img src={map} alt="Descriptive Alt Text" className="responsive-imageMap" />
      </div>    */}

     
     <MobileViewCard
                     card1Front={ProductImage1}
                     card1Back={ProductImage5}
                     card2Front={ProductImage6}
                     card2Back={ProductImage3}
                     card3Front={ProductImage4}
                     card3Back={ProductImage2}
                 />
      <Map/>

      <Counter />
      <TestimonialSlider />
                  
      <div className="section-heading">
        <h2>Our Certifications</h2>
        <p>Recognized and trusted by global quality standards</p>
      </div>

                  

      <div class="card-container">
        <div class="flip-card flip-cardcrt">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <img src={Certificate1} alt="Front Side" />
            </div>
            <div className="flip-card-back">
              <div className="card-back-content">
                <img src={logo} alt="Back" />
                <p className="caption">"The upcoming certification will be displayed here."</p>
              </div>
            </div>
          </div>
        </div>
        <div class="flip-card flip-cardcrt">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <img src={URC1} alt="Front Side" />
            </div>
            <div className="flip-card-back">
              <div className="card-back-content">
                <img src={URC2} alt="Back" />
                <p className="caption">Certificate</p>
              </div>
            </div>

          </div>
        </div>
        <div class="flip-card flip-cardcrt">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <img src={ProductImage1} alt="Front Side" />
            </div>
            <div className="flip-card-back">
              <div className="card-back-content">
                <img src={logo} alt="Back" />
                
                <p className="caption">
                  "The upcoming certification will be displayed here."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MobileViewCertificate
        card1Front={Certificate1}
        card1Back={logo}
        card2Front={URC1}
        card2Back={URC2}
        card3Front={ProductImage4}
        card3Back={ProductImage2}
      />
     


    </div>
  );
}

export default App;
